<template>
  <BgImageLayout title="Product types" :page="__guide.productTypes" icon-color="white">
    <ag-grid-wrapper
      ref="wrapper"
      :options="options"
      :actions="productTypeActions"
      :separator="true"
      :include-search-box="true"
      store-namespace="productTypes"
      service-namespace="product-types"
      @created="refreshData"
      @refresh-data="refreshData"
      @type-modal="newTypeModal = true"
    />

    <lm-dialog
      v-if="deletable"
      :uid="uid"
      :entity="deletable"
      :replacement-options="productTypeOptions"
      store-namespace="productTypes"
    />

    <form-create-product-type :showing="newTypeModal" @refresh="refreshData" @close="newTypeModal = false" />
  </BgImageLayout>
</template>

<script>
import { dateRenderer, dateSorter } from '@/lib/generic.utils'
import { LmGridOptions } from '@/lib/models/lm-grid-options.class'
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'
import LmEntityActions from '@components/ag-grid-helpers/EntityActions'
import FormCreateProductType from '@components/forms/FormCreateProductType'
import LmDialog from '@components/lm-blocks/Dialog'
import { uid } from 'quasar'
import { get } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'LmPageProductTypeIndex',

  components: {
    AgGridWrapper,
    LmDialog,
    FormCreateProductType
  },

  data() {
    return {
      deletable: null,
      uid: uid(),
      newTypeModal: false
    }
  },

  computed: {
    ...mapState({
      types: state => state.productTypes.all
    }),

    productTypeOptions() {
      return this.generateOptions({
        collection: this.types,
        excludeValue: get(this.deletable, 'id')
      })
    },

    productTypeActions() {
      return [
        {
          label: 'Create new product type',
          event: 'type-modal',
          type: 'button',
          color: 'tertiary',
          size: 'md'
        }
      ]
    },

    options() {
      let options = {
        rowData: this.types,
        context: {
          actions: [
            {
              icon: 'trash',
              tooltip: 'Delete',
              onClick: this.delete,
              color: 'faded'
            }
          ]
        },
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name',
            editable: true,
            cellRenderer: params => this.renderCellValue(params)
          },
          {
            headerName: 'Created',
            field: 'created_at',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Updated',
            field: 'updated_at',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Actions',
            cellRendererFramework: LmEntityActions
          }
        ]
      }
      return new LmGridOptions(options)
    }
  },

  methods: {
    refreshData() {
      this.$store.dispatch('productTypes/getAll')
    },

    delete(params) {
      this.$set(this, 'deletable', params.data)
      this.$store.dispatch('productTypes/deleteConfirmation', {
        id: this.deletable.id,
        dialogUid: this.uid
      })
    },

    renderCellValue(params) {
      return `<span>${params.value || 'N/A'}</span>`
    }
  }
}
</script>
